import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { catchError, map, Observable } from 'rxjs';
import { getFederatedLoginQuery, resendVerificationEmailMutation } from '../../../queries';
import { IFederatedLoginResponse, LoginMethod } from '../../../models';
import { SKIP_AUTH } from '../../interceptors/auth.interceptor';

@Injectable()
export class LoginFacade {
  constructor(private apollo: Apollo) {}

  public getFederatedLoginData(
    email: string,
    nonce: string,
    state: string,
    redirectUri: string,
    loginSource?: 'WEB' | 'MOBILE'
  ): Observable<IFederatedLoginResponse> {
    return this.apollo
      .query<{ federatedLogin: IFederatedLoginResponse }>({
        query: getFederatedLoginQuery,
        variables: {
          input: {
            email: email,
            nonce,
            state,
            redirectUri,
            loginMethod: LoginMethod.DEFAULT,
            loginSource,
          },
        },
        context: { httpContext: new HttpContext().set(SKIP_AUTH, true) },
      })
      .pipe(map(result => result.data.federatedLogin));
  }

  public resendVerificationEmail(): Observable<boolean> {
    return this.apollo
      .mutate<boolean>({
        mutation: resendVerificationEmailMutation,
        context: { httpContext: new HttpContext().set(SKIP_AUTH, true) },
      })
      .pipe(
        map(result => result && result.data),
        catchError((error: Error) => {
          console.error(error);
          throw new Error(error.message);
        })
      );
  }
}
